export const toReactHookFormErrorPath = (apiFieldPath) =>
    String(apiFieldPath).replace(/\[(\d+)\]/g, ".$1");
